import { ReactElement, useState, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const SignatureSection = (): ReactElement => {
  const { t: tSignature } = useTranslation('', { keyPrefix: '$local.$signatureSection' });
  const { t: tLinks } = useTranslation('', { keyPrefix: '$local.$homePageLinks.signatureSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });

  const [isMobile, setIsMobile] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Signature products data
  const signatureProducts = [
    {
      key: 'bloody-mary',
      link: tSignature('bloodyMary.link'),
      image: '/images/homepage/hp-signature-bloody-mary.webp',
      title: tSignature('bloodyMary.title'),
      subtitle: tSignature('bloodyMary.subtitle'),
      description: tSignature('bloodyMary.description'),
      alt: tSignature('bloodyMary.alt'),
    },
    {
      key: 'room-fragrance-signature',
      link: tSignature('roomFragranceSignature.link'),
      image: '/images/homepage/hp-room-fragrance-signature.webp',
      title: tSignature('roomFragranceSignature.title'),
      subtitle: tSignature('roomFragranceSignature.subtitle'),
      description: tSignature('roomFragranceSignature.description'),
      alt: tSignature('roomFragranceSignature.alt'),
    },
    {
      key: 'vilebrequin',
      link: tSignature('vilebrequin.link'),
      image: '/images/homepage/hp-signature-vilebrequin.webp',
      title: tSignature('vilebrequin.title'),
      subtitle: tSignature('vilebrequin.subtitle'),
      description: tSignature('vilebrequin.description'),
      alt: tSignature('vilebrequin.alt'),
    },
    {
      key: 'polo-kit',
      link: tSignature('poloKit.link'),
      image: '/images/homepage/hp-signature-polo-kit.webp',
      title: tSignature('poloKit.title'),
      subtitle: tSignature('poloKit.subtitle'),
      description: tSignature('poloKit.description'),
      alt: tSignature('poloKit.alt'),
    },
  ];

  const renderSignatureCard = (product: (typeof signatureProducts)[0]) => (
    <Link href={product.link} className="target">
      <div className="main-hp stack-float-wrapper">
        <picture>
          <img
            loading="lazy"
            decoding="async"
            fetchPriority="low"
            src={product.image}
            alt={product.alt}
            width={1300}
            height={867}
          />
        </picture>
        <div className="stack-float">
          <p className="eyebrow">{product.subtitle}</p>
          <h2>
            {product.key === 'vilebrequin' ? (
              <>
                Vilebrequin for <span className="st-regis">St. Regis</span>
              </>
            ) : (
              product.title
            )}
          </h2>
          <p>{product.description}</p>
          <span className="btn-main">{tButton('shopNow')}</span>
        </div>
      </div>
    </Link>
  );

  return (
    <section className="base-section signature-section hp-section">
      <div className="hp_signature">
        <div>
          <h2>
            <span className="eyebrow">{tSignature('signatureEyebrow')}</span>
            {tSignature('signatureTitle')}
          </h2>
          <p>{tSignature('signatureDescription')}</p>
        </div>

        {isMobile ? (
          // Mobile: Swiper implementation
          <div className="swiper-container">
            <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={20}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true }}
              className="signature-swiper"
            >
              {signatureProducts.map(product => (
                <SwiperSlide key={product.key}>{renderSignatureCard(product)}</SwiperSlide>
              ))}
            </Swiper>
          </div>
        ) : (
          // Desktop: Hover navigation implementation
          <>
            <ul className="tabs clearfix">
              {signatureProducts.map((product, index) => (
                <li
                  key={product.key}
                  className={activeTab === index ? 'active' : ''}
                  onMouseEnter={() => setActiveTab(index)}
                >
                  <h3>{product.title}</h3>
                </li>
              ))}
            </ul>

            <div className="tab_container">
              <div className="tab_content">
                <ul className="colors clearfix">
                  <li className="linens-white current">
                    {renderSignatureCard(signatureProducts[activeTab])}
                  </li>
                </ul>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default SignatureSection;
